var global = window

global.lastEdit = "";

global.callbackTinyMCE = function (ed) {
    var textarea = document.getElementsByName(ed.editorId)[0];
    textarea.onchange();
}

global.changeSelectedOption = function (option, value) {
    option.parentNode.parentNode.childNodes[2].value = option.parentNode.parentNode.value = value;
    option.parentNode.parentNode.childNodes[0].innerHTML = option.innerHTML;

    for (var i = 0; i < option.parentNode.childNodes.length; i++) {
        option.parentNode.childNodes[i].className = option.parentNode.childNodes[i].className.replace('customSelectOptionSelected', '');
    }

    option.className += " customSelectOptionSelected";

    option.parentNode.style.display = "none";

    if (option.parentNode.parentNode.onchange) {
        option.parentNode.parentNode.onchange();
    }
}

global.customSelect = function (objSelect) {
    var newSelect = document.createElement('div');
    newSelect.className = objSelect.className;
    newSelect.id = objSelect.id;
    newSelect.style.cssText = objSelect.style.cssText;
    newSelect.style.position = "relative";
    var innerSelect = document.createElement('div');
    innerSelect.className = "customSelectText";
    var btSelect = document.createElement('div');
    btSelect.className = "customSelectBtn";
    var hiddenSelect = document.createElement('input');
    hiddenSelect.name = objSelect.name;
    hiddenSelect.id = objSelect.id;
    hiddenSelect.type = "hidden";
    var listSelect = document.createElement('div');
    listSelect.className = "customSelectList";
    listSelect.style.display = "none";
    listSelect.style.position = "absolute";
    listSelect.style.zIndex = "1000";

    newSelect.appendChild(innerSelect);
    newSelect.appendChild(btSelect);
    newSelect.appendChild(hiddenSelect);
    newSelect.appendChild(listSelect);

    // Stocke les options
    for (var i = 0; i < objSelect.options.length; i++) {
        selectedClass = "";
        if (objSelect.options[i].selected) {
            innerSelect.innerHTML = objSelect.options[i].innerHTML;
            hiddenSelect.value = objSelect.options[i].value;
            selectedClass = "customSelectOptionSelected "
        }
        listSelect.innerHTML += "<div class='customSelectOption " + selectedClass + objSelect.options[i].className + "' onclick='changeSelectedOption(this, \"" + objSelect.options[i].value + "\")' onmouseover='this.className+=\" customSelectOptionOver\"' onmouseout=\"this.className=this.className.replace(\'customSelectOptionOver\',\'\')\">" + objSelect.options[i].innerHTML + "</div>";
    }

    // Si la liste mesure plus de 10 de long, on met une scroll
    if (objSelect.options.length > 9) {
        listSelect.style.overflowY = "scroll";
        listSelect.style.overflowX = "hidden";
        listSelect.style.height = "150px";
    }

    // Functions
    newSelect.onchange = objSelect.onchange;
    btSelect.onclick = innerSelect.onclick = function () {
        this.parentNode.childNodes[3].style.display = (this.parentNode.childNodes[3].style.display == "block") ? "none" : "block";
    }

    objSelect.parentNode.insertBefore(newSelect, objSelect);
    objSelect.parentNode.removeChild(objSelect);
}


// ================== Pompe toutes les données d'un formulaire =======================================
global.getForm = function (obj) {
    let data = "";

    // Les Selects
    let tmp = obj.getElementsByTagName("select");
    let i = 0;
    for (i = 0; i < tmp.length; i++) {
        var sel = tmp[i];
        if (sel.selectedIndex >= 0) {
            data += sel.id + "=" + sel.options[sel.selectedIndex].value + "&";
        }
    }

    // Les Divs de modif
    tmp = obj.getElementsByTagName("div");
    for (i = 0; i < tmp.length; i++) {
        if (tmp[i].className == "editZone") {
            if (!tmp[i].value) {
                data += tmp[i].id + "=" + escape(tmp[i].innerHTML) + "&";
            } else {
                data += tmp[i].id + "=" + escape(tmp[i].value) + "&";
            }
        }
    }

    // Les Textareas
    tmp = obj.getElementsByTagName("textarea");
    for (i = 0; i < tmp.length; i++) {
        data += tmp[i].id + "=" + tmp[i].value + "&";
    }

    // Les inputs
    tmp = obj.getElementsByTagName("input");

    for (i = 0; i < tmp.length; i++) {
        switch (tmp[i].type) {
            case "text":
                data += tmp[i].id + "=" + tmp[i].value + "&";
                break;
            case "password":
                data += tmp[i].id + "=" + tmp[i].value + "&";
                break;
            case "hidden":
                if (tmp[i].id != "param") {
                    data += tmp[i].id + "=" + tmp[i].value + "&";
                }
                break;
            case "checkbox":
                if ($(tmp[i]).attr('value') && $(tmp[i]).attr('value') != 'on' && $(tmp[i]).attr('value') != '1') {
                    if (tmp[i].checked) {
                        data += tmp[i].name + "=" + tmp[i].value + "&";
                    }
                }
                else {
                    if (tmp[i].checked) {
                        data += tmp[i].name + "=1&";
                    } else {
                        data += tmp[i].name + "=0&";
                    }
                }
                break;
            case "radio":
                if (tmp[i].checked) {
                    data += tmp[i].id + "=" + tmp[i].value + "&";
                }
                break;
        }
    }

    /*
    // les inputs stylisé
    $('img.checkbox').each(function(index) {
        if ($(this).attr('checked')) {
            data += $(this).attr('id') + "=1&";
        }
        else {
            data += $(this).attr('id') + "=0&";
        }
    })
    */

    return data;
}

global.updateCheckbox = function (selector) {
    $(selector).attr('src', "assets/images/frame/checkbox" + (($(selector).attr('checked')) ? "Checked" : "") + ".png");
}


global.emergencySave = function (alt) {
    alt = typeof(alt) != 'undefined' ? alt : "";

    if ((lastEdit != "" || alt != "") && document.getElementById("action").value != 2) {
        // Si un ajax roule, on attend un peu
        if (ajaxRunning) {
            setTimeout("emergencySave('" + lastEdit + "')", 100);
        } else if (typeof tinymce == 'object') {
            $.each(tinymce.editors, function (key, editor) {
                if (editor) {
                    if (editor.isDirty && editor.isDirty()) {
                        const confirmation = confirm(
                            'Voulez-vous sauvegarder le contenu du champ ' +
                                editor.id +
                                ' avant de continuer ?'
                        )
                        if (confirmation) {
                            editor.execCommand('mceSave')
                        }
                    }
                    editor.remove()
                }
            })
        }
    }
}

// ================== Flush tous les divs modifiables les laissants fixes ============================
global.flushModifiableDivs = function () {
    let tmp = document.getElementsByTagName("div");
    let i = 0;
    for (i = 0; i < tmp.length; i++) {
        if (tmp[i].className == "editZone") {
            tmp[i].onclick = function () {
            };
            tmp[i].onchange = function () {
            };
            tmp[i].className = "editZoneDisabled";
            tmp[i].style.cursor = "default";
        }
    }
    tmp = document.getElementsByTagName("span");
    for (i = 0; i < tmp.length; i++) {
        if (tmp[i].className == "editZone") {
            tmp[i].onclick = function () {
            };
            tmp[i].onchange = function () {
            };
            tmp[i].className = "editZoneDisabled";
            tmp[i].style.cursor = "default";
        }
    }
}




// ================== Switch tous les divs =======================================
var isSwitchingAll = false;
global.switchAll = function () {
    try {
        isSwitchingAll = true;
        let tmp = document.getElementsByTagName("div");
        for (let i = 0; i < tmp.length; i++) {
            if ((tmp[i].className).indexOf("editZone") != -1) {
                //var otherClasses = (tmp[i].className).replace('editZone','');
                let tmpId = tmp[i].id;
                tmp[i].setAttribute("onchange", tmp[i].getAttribute("changequandmeme"));
                tmp[i].setAttribute("change", null);
                tmp[i].style.cursor = "default";
                tmp[i].onclick();
                i--; // Recule de un comme on enleve un élément du tableau

                // Flush les deux boutons
                //document.getElementById(tmpId).parentNode.removeChild(document.getElementById(tmpId).nextSibling);
                var obj = document.getElementById(tmpId);
                if (obj) {
                    if (document.getElementById(obj.id + "_bt_canc")) {
                        $('#' + obj.id + "_bt_canc").remove();
                    }
                    if (document.getElementById(obj.id + "_bt_ok")) {
                        $('#' + obj.id + "_bt_ok").remove();
                    }
                    document.getElementById(tmpId).onblur = null;
                } else {
                    var obj = document.getElementById(tmpId + "0");
                    if (document.getElementById(obj.id + "_bt_ok")) {
                        $('#' + obj.id + "_bt_ok").remove();
                    }
                    obj.onblur = null;
                }

            }
        }
        isSwitchingAll = false;
    }
    catch (e) {
        console.log(e)
        isSwitchingAll = false;
    }
}


// ================== Switch d'un div vers un INPUT ==============================

global.switchBack = function (obj) {
    setTimeout(function(){
        switchBackDo(obj);
    }, 10);
}

global.switchBackDo = function (obj) {
    try {
        let lastActive = $(document.activeElement);

        if (lastActive.closest('.mceSplitButtonMenu').length) {
            return false;
        }

        // Flush l'id
        let lastEdit = "";

        // Enleve le FCK au besoin
        if (tinyMCE.get(obj.id)) {
            tinyMCE.execCommand('mceRemoveControl', false, obj.id);
            obj.value = obj.value.replace(/&nbsp;/g, ' ');
        }


        // Recré l'objet d'avant
        var div = document.createElement(obj.old);

        // Si c'est un select on met le texte, sinon la valeur
        if (obj.tagName == "SELECT" || obj.tagName == "select") {
            $(obj).select2();
            $(obj).select2('destroy');
            div.innerHTML = obj.options[obj.selectedIndex].text;
            div.value = htmlentities(obj.options[obj.selectedIndex].value);
        } else {
            div.innerHTML = obj.value;
            div.value = htmlentities(div.innerHTML);
            div.value = div.value.replace(/&nbsp;/g, ' ');
            div.value = div.value.replace(/<br \/>/g, '\n');
            div.value = div.value.replace(/<br>/g, '\n');
        }
        // Si le contenu est vide... met au moins un espace;
        if (div.innerHTML == "") {
            div.innerHTML = " ";
        }

        // Autre attributs
        div.id = obj.id;
        div.className = obj.bckClass;
        if (!obj.value) {
            div.className = div.className.replace('yellowNote', 'emptyYellowNote');
        }
        else {
            div.className = div.className.replace('emptyYellowNote', 'yellowNote');
        }
        div.style.width = obj.style.width;

        // Flush les boutons et remet l'objet
        $("#" + obj.id + "_bt_ok").parent().find('.ui-datepicker-trigger').remove();
        if (document.getElementById(obj.id + "_bt_canc")) {
            obj.parentNode.removeChild(document.getElementById(obj.id + "_bt_canc"));
        }
        if (document.getElementById(obj.id + "_bt_ok")) {
            obj.parentNode.removeChild(document.getElementById(obj.id + "_bt_ok"));
        }

        if (obj.parentNode) {
            obj.parentNode.replaceChild(div, obj);
        }

        // On restaure le javascript
        div.setAttribute("onclick", obj.getAttribute("bckJS"));
        div.setAttribute("onchange", obj.getAttribute("change"));
        div.setAttribute("onkeyup", obj.getAttribute("onkeyup"));

        // Restaure les styles
        div.setAttribute("style", obj.getAttribute("bckStyle"));
    }
    catch (e) {
        console.log(e);
        alert("Un problème est survenu avec la soumission du formulaire.");
        document.getElementById('errorDiv').innerHTML = e.message + " : (switchBack) Ligne=" + e.lineNumber;
    }
}

global.switchBackList = function (inputArray, parent, oldObj, save) {
    try {
        var div = document.createElement('DIV');

        if (save) {
            var html = "<ul>"
            for (i = 0; i < inputArray.length; ++i) {
                if (inputArray[i].value != "") {
                    html += "<li>" + inputArray[i].value + "</li>"
                }
            }
            html += "</ul>";
            div.innerHTML = html;
            $(parent).empty();

            // On restaure le javascript
            div.id = oldObj.id;
            div.className = oldObj.className;

            var nomFonction = oldObj.getAttribute("onclick").split("(")[0];
            var parametreArray = oldObj
                .getAttribute("onclick")
                .replace(nomFonction, "")
                .replace("(", "")
                .replace(")", "")
                .split(",");

            parametreArray[6] = "'"
            //On remplace les valeur
            for (i = 0; i < inputArray.length; ++i) {
                if (inputArray[i].value != "") {
                    parametreArray[6] = parametreArray[6] + inputArray[i].value + ";";
                }
            }
            parametreArray[6] = parametreArray[6] + "'"

            var onclick = nomFonction + "(";

            for (i = 0; i < parametreArray.length; ++i) {
                onclick = onclick + parametreArray[i];
                if (i < parametreArray.length - 1) {
                    onclick = onclick + ",";
                }
            }

            onclick = onclick + ")";

            div.setAttribute("onclick", onclick);
            div.setAttribute("onchange", oldObj.getAttribute("onchange"));
            div.setAttribute("onkeyup", oldObj.getAttribute("onkeyup"));
            div.setAttribute("style", oldObj.getAttribute("style"));
            $(parent).append(div);
        } else {
            $(parent).html(oldObj);
        }
    }
    catch (e) {
        alert("Dire à Claude de venir voir tout de suite, ou faire un print screen.");
        document.getElementById('errorDiv').innerHTML = e.message + " : (switchBack) Ligne=" + e.lineNumber;
    }
}

// ================== Switch d'un div vers un FCK ==============================
global.switchToFCK = function (obj, width, height) {
    // Garde le id en mémoire au besoin
    emergencySave();
    lastEdit = obj.id;

    // Valeurs par défaut des parametres
    let type = "textarea";
    width = typeof(width) != 'undefined' ? width : 700;
    height = typeof(height) != 'undefined' ? height : 300;

    // Crée un textarea et remplace le div
    var input = document.createElement(type);
    input.value = html_entity_decode(obj.innerHTML);
    input.id = obj.id;
    input.old = obj.tagName;
    input.bckText = html_entity_decode(obj.innerHTML);
    input.bckClass = obj.className;
    input.setAttribute("bckJS", obj.getAttribute("onclick"));
    input.setAttribute("change", obj.getAttribute("onchange"));
    input.setAttribute("bckStyle", obj.getAttribute("style"));
    input.style.width = width + "px";
    input.style.height = height + "px";
    obj.parentNode.replaceChild(input, obj);
    input.focus();

    $(input).tinymce(editorPlugin.config);
}


// ================== Switch d'un div vers un INPUT ==============================
global.switchToInput = function (obj, type, width, height, validation, addClasses) {

    // Garde le id en mémoire au besoin
    //emergencySave();
    lastEdit = obj.id;

    // Valeurs par défaut des parametres
    type = typeof(type) != 'undefined' ? type : "textarea";
    width = typeof(width) != 'undefined' ? width : 300;
    height = typeof(height) != 'undefined' ? height : 50;


    // Crée un textarea et remplace le div
    var input = document.createElement(type);
    input.value = $.trim(html_entity_decode(obj.innerHTML).replace(/<br>/g, '\n'));
    input.id = obj.id;
    input.old = obj.tagName;
    input.bckText = html_entity_decode(obj.innerHTML);
    input.bckClass = obj.className;
    input.setAttribute("bckJS", obj.getAttribute("onclick"));
    input.setAttribute("change", obj.getAttribute("onchange"));
    input.setAttribute("onkeyup", obj.getAttribute("onkeyup"));
    input.setAttribute("bckStyle", obj.getAttribute("style"));
    input.setAttribute("type", obj.getAttribute("type"));
    if (obj.getAttribute("placeholder"))
        input.setAttribute("placeholder", obj.getAttribute("placeholder"));
    if (typeof addClasses != 'undefined') {
        input.setAttribute("class", addClasses);
    }
    if (validation == 'date') {
        width = width - 20;
    }

    input.style.width = width + "px";
    input.style.height = height + "px";

    //En commentaire car fait un mauvais redimensionnement, se base maintenant sur la largeur passée em paramètre (input.style.width = width + "px";)
    //$(input).width($(obj).width()-42);
    obj.parentNode.replaceChild(input, obj);
    input.select();
    input.focus();

    // Le bouton cancel
    var btCanc = document.createElement("img");
    btCanc.src = 'assets/images/icons/icon-delete-small.png';
    btCanc.id = input.id + "_bt_canc";
    btCanc.hspace = "3";
    btCanc.style.cursor = "pointer";
    input.parentNode.insertBefore(btCanc, input.nextSibling);
    btCanc.onclick = function () {
        clearTimeout(timerBuffer);
        document.getElementById(input.id).value = document.getElementById(input.id).bckText;
        switchBack(document.getElementById(input.id));
    };

    // Le bouton OK
    var btOK = document.createElement("img");
    btOK.src = 'assets/images/icons/icon-crochet.png';
    btOK.id = input.id + "_bt_ok";
    btOK.hspace = "3";
    btOK.style.cursor = "pointer";
    input.parentNode.insertBefore(btOK, input.nextSibling);

    //btOK.onclick = function(){ input.onchange(); }
    btOK.onclick = function () {
        clearTimeout(timerBuffer);
        if (input.onchange) {
            input.onchange();
        }
        else if (input.savemethod) {
            input.savemethod()
        }
        else {
            alert('Pas de méthode de sauvegarde définie...');
        }
    };

    if (validation == 'date') {
        var now = new Date();
        var currentYear = now.getFullYear();
        $(input).datepicker({
            dateFormat: "yy-mm-dd",
            showOn: "button",
            buttonImageOnly: true,
            buttonImage: "assets/images/icons/icon-calendrier.png",
            monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
            changeYear: true,
            dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
            yearRange: (currentYear - 70) + ':' + (currentYear + 20),
        });
    }

    if (validation == 'color') {
        var myPicker = new jscolor.color(input, {required:false})
        myPicker.showPicker();
    }


    // Save onblur
    if (validation != 'color') {
        input.onchange = function () {
            this.value = this.value.replace(/\n/g, "<br />");
            timerBuffer = setTimeout('switchToInputValidation("' + input.getAttribute("change").replace(/this/g, 'document.getElementById(\'' + input.id + '\')') + '", "' + htmlentities(this.value) + '", "' + input.id + '", "' + validation + '" )', 200);
        }
    }
    else {
        input.savemethod = function () {
            this.value = this.value.replace(/\n/g, "<br />");
            timerBuffer = setTimeout('switchToInputValidation("' + input.getAttribute("change").replace(/this/g, 'document.getElementById(\'' + input.id + '\')') + '", "' + htmlentities(this.value) + '", "' + input.id + '", "' + validation + '" )', 200);
        }
    }
}

global.switchToMultipleInput = function (obj, type, width, height, validation, addClasses, valueArray) {

    // Garde le id en mémoire au besoin
    lastEdit = obj.id;
    // Valeurs par défaut des parametres
    type = typeof(type) != 'undefined' ? type : "textarea";
    width = typeof(width) != 'undefined' ? width : 300;
    height = typeof(height) != 'undefined' ? height : 50;

    valueArray = valueArray.split(";");
    var parent = obj.parentElement;
    obj.parentElement.removeChild(obj);

    var arrayInput = [];
    for (i = 0; i < valueArray.length; ++i) {
        //if (valueArray[i] != ""){
        // Crée un textarea et remplace le div
        var input = document.createElement(type);
        input.value = $.trim(valueArray[i].replace(/<br>/g, '\n'));
        input.id = obj.id + i;
        input.old = obj.tagName;
        input.bckText = html_entity_decode(obj.innerHTML);
        input.bckClass = obj.className;
        input.setAttribute("bckJS", obj.getAttribute("onclick"));
        input.setAttribute("change", obj.getAttribute("onchange"));
        input.setAttribute("onkeyup", obj.getAttribute("onkeyup"));
        input.setAttribute("bckStyle", obj.getAttribute("style"));
        input.setAttribute("type", obj.getAttribute("type"));
        if (typeof addClasses != 'undefined') {
            input.setAttribute("class", addClasses);
        }
        if (validation == 'date') {
            width = width - 20;
        }

        input.style.width = width + "px";
        input.style.height = height + "px";
        //En commentaire car fait un mauvais redimensionnement, se base maintenant sur la largeur passée em paramètre (input.style.width = width + "px";)
        //$(input).width($(obj).width()-42);

        $(parent).append(input);
        //obj.parentNode.replaceChild(input,obj);

        input.select();
        input.focus();

        // Le bouton cancel
        var btCanc = document.createElement("img");
        btCanc.src = 'assets/images/icons/icon-delete-small.png';
        btCanc.id = input.id + "_bt_canc";
        btCanc.hspace = "3";
        btCanc.style.cursor = "pointer";
        parent.insertBefore(btCanc, input.nextSibling);
        btCanc.onclick = function () {
            clearTimeout(timerBuffer);
            $(this).prev().remove();
            $(this).remove();
        };
        arrayInput.push(input);
    }

    var btOK = document.createElement("img");
    btOK.src = 'assets/images/icons/icon-crochet.png';
    btOK.id = input.id + "_bt_ok";
    btOK.hspace = "3";
    btOK.style.cursor = "pointer";
    btOK.onclick = function () {
        clearTimeout(timerBuffer);
        if (onchange) {
            onchange();
        }
        else if (input.savemethod) {
            input.savemethod()
        }
        else {
            alert('Pas de méthode de sauvegarde définie...');
        }
    };

    var btAdd = document.createElement("img");
    btAdd.src = 'assets/images/icons/icon-add.png';
    btAdd.id = input.id + "_bt_add";
    btAdd.hspace = "3";
    btAdd.style.cursor = "pointer";
    //input.parentNode.insertBefore(btOK, input.nextSibling);

    //btOK.onclick = function(){ input.onchange(); }
    btAdd.onclick = function () {
        clearTimeout(timerBuffer);
        var inputArray = $(parent).children('input');
        for (i = 0; i < inputArray.length; ++i) {
            $(inputArray[i]).attr("id", obj.id + i);
        }
        var input = document.createElement(type);
        input.id = obj.id + inputArray.length;
        input.old = obj.tagName;
        input.bckText = html_entity_decode(obj.innerHTML);
        input.bckClass = obj.className;
        input.setAttribute("bckJS", obj.getAttribute("onclick"));
        input.setAttribute("change", obj.getAttribute("onchange"));
        input.setAttribute("onkeyup", obj.getAttribute("onkeyup"));
        input.setAttribute("bckStyle", obj.getAttribute("style"));
        input.setAttribute("type", obj.getAttribute("type"));
        if (typeof addClasses != 'undefined') {
            input.setAttribute("class", addClasses);
        }
        if (validation == 'date') {
            width = width - 20;
        }

        input.style.width = width + "px";
        input.style.height = height + "px";

        var btCanc = document.createElement("img");
        btCanc.src = 'assets/images/icons/icon-delete-small.png';
        btCanc.id = input.id + "_bt_canc";
        btCanc.hspace = "3";
        btCanc.style.cursor = "pointer";
        //parent.insertBefore(btCanc, input.nextSibling);
        btCanc.onclick = function () {
            clearTimeout(timerBuffer);
            $(this).prev().remove();
            $(this).remove();
            var inputArray = $(parent).children('input');
            for (i = 0; i < inputArray.length; ++i) {
                $(inputArray[i]).attr("id", obj.id + i);
            }
        };

        arrayInput.push(input);
        $(input).insertBefore($(parent).find($("div")));
        $(btCanc).insertAfter($(input));
        $(input).select();
    };

    $(parent).append("<div style='padding-top:7px;'></div>");
    $(parent).find($("div")).append(btAdd);
    $(parent).find($("div")).append(btOK);

    if (validation != 'color') {
        var onchange = function () {
            modifBenevole(arrayInput, addClasses);
            switchBackList($(parent).children('input'), parent, obj, true);
        }
    }
    else {
        input.savemethod = function () {
            this.value = this.value.replace(/\n/g, "<br />");
            timerBuffer = setTimeout('switchToInputValidation("' + input.getAttribute("change").replace(/this/g, 'document.getElementById(\'' + obj.id + '\')') + '", "' + htmlentities(this.value) + '", "' + obj.id + '", "' + validation + '" )', 200);
        }
    }

}

global.switchToInputValidation = function (code, valeur, input_id, validation) {
    if (validation == 'date') {
        var date_validation = new RegExp(/^(\d{4}\-\d\d\-\d\d([tT][\d:\.]*)?)([zZ]|([+\-])(\d\d):?(\d\d))?$/);
        if (!date_validation.test(valeur) && valeur) {
            clearTimeout(timerBuffer);
            document.getElementById(input_id).value = document.getElementById(input_id).bckText;
            switchBack(document.getElementById(input_id));
            document.getElementById('errorDiv').innerHTML = "<span style='color:#ff4444'>La date saisie n'es pas valide !</span>";
            return false;
        }
    }

    eval(code);
}


// ================== Switch d'un div vers un INPUT ==============================
global.switchToSelect = function (obj, arrOptions, arrVals, arrGroups, arrClass) {
    // Garde le id en mémoire au besoin
    emergencySave();
    lastEdit = obj.id;

    var input = document.createElement("select");
    var selected = 0;
    var currentGroup = '';

    // Liste les options
    for (var i = 0; i < arrOptions.length; i++) {
        if (!isNaN(arrVals[i]) || true) {
            if (arrGroups) {
                if (arrGroups[i] != currentGroup) {
                    if (elGroupNew) {
                        try {
                            input.appendChild(elGroupNew, null); // Pour tout sauf IE
                        }
                        catch (ex) {
                            input.appendChild(elGroupNew); // Pour IE...
                        }
                    }

                    currentGroup = arrGroups[i];
                    var elGroupNew = document.createElement('optgroup');
                    elGroupNew.label = currentGroup;
                }
            }


            let elOptNew = document.createElement('option');
            elOptNew.text = arrOptions[i];
            elOptNew.innerHTML = arrOptions[i];
            elOptNew.value = arrVals[i];
            if (arrClass) $(elOptNew).addClass(arrClass[i]);

            // Si c'est le même que le texte
            //if (obj.innerHTML == arrOptions[i] || html_entity_decode(obj.innerHTML) == arrOptions[i])
            if (obj.value == arrVals[i] || obj.getAttribute("value") == arrVals[i]) {
                selected = i;
            }

            if (elGroupNew) {
                try {
                    elGroupNew.appendChild(elOptNew, null); // Pour tout sauf IE
                }
                catch (ex) {
                    elGroupNew.appendChild(elOptNew); // Pour IE...
                }
            }
            else {
                try {
                    input.appendChild(elOptNew, null); // Pour tout sauf IE
                }
                catch (ex) {
                    input.appendChild(elOptNew); // Pour IE...
                }
            }
        }
    }

    if (elGroupNew) {
        try {
            input.appendChild(elGroupNew, null); // Pour tout sauf IE
        }
        catch (ex) {
            input.appendChild(elGroupNew); // Pour IE...
        }
    }

    // Embarque les autres attributs et switch l'objet
    input.id = obj.id;
    input.old = obj.tagName;
    input.bckClass = obj.className;


    input.setAttribute("bckJS", obj.getAttribute("onclick"));
    input.setAttribute("change", obj.getAttribute("onchange"));
    input.setAttribute("bckStyle", obj.getAttribute("style"));
    input.setAttribute("style", obj.getAttribute("style"));
    input.bckText = html_entity_decode(obj.innerHTML);
    input.selectedIndex = selected;
    input.bckSelected = selected;
    if ($(obj).is(":visible"))
        $(input).width($(obj).width() - 32);
    obj.parentNode.replaceChild(input, obj);
    input.focus();

    // Le bouton cancel
    var btCanc = document.createElement("img");
    btCanc.src = 'assets/images/icons/icon-delete-small.png';
    btCanc.id = input.id + "_bt_canc";
    btCanc.hspace = "3";
    btCanc.style.cursor = "pointer";
    input.parentNode.insertBefore(btCanc, input.nextSibling);
    btCanc.onclick = function () {
        clearTimeout(timerBuffer);
        document.getElementById(input.id).selectedIndex = document.getElementById(input.id).bckSelected;
        switchBack(document.getElementById(input.id));
    };

    // Le bouton OK
    var btOK = document.createElement("img");
    btOK.src = 'assets/images/icons/icon-crochet.png';
    btOK.id = input.id + "_bt_ok";
    btOK.hspace = "3";
    btOK.style.cursor = "pointer";
    input.parentNode.insertBefore(btOK, input.nextSibling);
    //btOK.onclick = function(){ input.onchange(); }
    btOK.onclick = function () {
        clearTimeout(timerBuffer);
        input.onchange();
    };

    // Save onblur
    input.onchange = function () {
        timerBuffer = setTimeout('eval("' + input.getAttribute("change").replace(/this/g, 'document.getElementById(\'' + input.id + '\')') + '")', 200);
    }

    $(input).addClass('select2')
    $(input).select2();
    if (!isSwitchingAll) $(input).select2('open');
}
